import { Component, ChangeDetectorRef } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalConfig,
} from "@ng-bootstrap/ng-bootstrap";
import $ from "jquery";
import { HttpService } from "../../service/HTTPService/HttpService";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { Globals } from "../../globals";
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { AlarmsComponent } from "../alarms/alarms.component";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
@Component({
  selector: "app-actions-cell",
  template: `
    <!-- <select
      style="height: 33px;font-size: 13px;width: 96px;margin-top:3px;margin-left:-15px;"
      class="form-control"
      [(ngModel)]="selectedoption"
      (change)="
        optionChanged(
          $event.target.value,
          ackModal,
          clearModal,
          escalateModal,
          descriptionModal,
          createTT
        )
      "
      name="sel2"
    >
      <option class="newOption" value="Action" disabled selected>Action</option>
      <option class="newOption" value="Description">Description</option>
      <hr />
      <option class="newOption" value="dtldashbrd">Site Details</option>
      <option class="newOption" value="alrmHistory">Alarm History</option>
    </select> -->
    <select
      style="height: 33px;font-size: 13px;width: 96px;margin-top:3px;margin-left:-15px;"
      class="form-control"
      [(ngModel)]="selectedoption"
      (change)="
        optionChanged(
          $event.target.value,
          ackModal,
          clearModal,
          escalateModal,
          descriptionModal,
          createTT
        )
      "
      name="sel2"
    >
      <option class="newOption" value="Action" disabled selected>Action</option>
      <!-- <option class="newOption" [disabled]="disableAck" value="Acknowledge">
        Acknowledge
      </option> -->
      <!-- <option class="newOption" [disabled]="disableClear" value="Clear">
        Clear
      </option> -->
      <option class="newOption" value="CreateTT" [disabled]="disableTT">
        Create TT
      </option>
      <!-- <option class="newOption" value="Escalate">Notify</option> -->
      <!-- <option class="newOption" value="Description">Description</option> -->
      <hr />
      <option class="newOption" value="dtldashbrd">Site Details</option>
      <option class="newOption" value="alrmHistory">Alarm History</option>
    </select>
    <ng-template #ackModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Acknowledge</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="comment">Describe the alarm</label>
          <textarea
            class="form-control"
            rows="5"
            #comment
            id="ackcomment"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          value="cancelClick"
          (click)="modal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          value="ackClick"
          (click)="modal.dismiss('ack' + '_' + comment.value)"
        >
          Acknowledge
        </button>
      </div>
    </ng-template>
    <ng-template #clearModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Clear Alarm</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="clearcomment">Comment</label>
          <textarea
            class="form-control"
            rows="5"
            #clearcomment
            id="clearcomment"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          value="cancelClick"
          (click)="modal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          value="ackClick"
          (click)="modal.dismiss('clear' + '_' + clearcomment.value)"
        >
          Clear
        </button>
      </div>
    </ng-template>
    <ng-template #escalateModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Notify</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5" id="escalateHeaders">
                <p>Site ID | Name:</p>
                <p>Field Engineer ID:</p>
                <p id="enggId">Field Engineer:</p>
                <p id="enggPhn">Contact Number:</p>
                <p>Alarm:</p>
                <p>Generated On</p>
              </div>
              <div class="col-md-7">
                <div class="form-group">
                  <p
                    title="{{ siteid_sitename }}"
                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "
                  >
                    {{ siteid_sitename }}
                  </p>
                  <p #enggId style="word-break: break-all;">
                    {{ fieldEnggId }}
                  </p>
                  <p
                    #enggName
                    title="{{ fieldEnggName }}"
                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{ fieldEnggName }}
                  </p>
                  <p #enggPhn style="word-break: break-all;">
                    {{ fieldEnggContact }}
                  </p>
                  <p
                    title="{{ alarms }}"
                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{ alarms }}
                  </p>
                  <p style="word-break: break-all;">{{ generatedOn }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" id="smsDiv">
                  <div id="chbk1">
                    <input
                      checked
                      type="checkbox"
                      class="form-check-input"
                      id="smsCheck"
                      (change)="onChange('smsCheck', $event.target.checked)"
                      style="margin-top: 10px;"
                    />
                    <label
                      style="padding-top: 7px;"
                      class="form-check-label"
                      for="smsCheck"
                      >SMS</label
                    >
                    <div style="float:right;width:85%;padding-bottom:10px">
                      <input
                        type="text"
                        pattern="d*"
                        maxlength="10"
                        class="form-control"
                        disabled="true"
                        id="enggContact"
                        #enggPhn1
                      />
                    </div>
                  </div>
                  <textarea
                    #smstext
                    style="width:340px"
                    class="form-control"
                    rows="3"
                    id="smsTextArea"
                    disabled="true"
                    >{{ smsText }}</textarea
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" id="emailDiv">
                  <div id="chbk2">
                    <input
                      checked
                      type="checkbox"
                      class="form-check-input"
                      id="emailCheck"
                      (change)="onChange('emailCheck', $event.target.checked)"
                      style="margin-top: 10px;"
                    />
                    <label
                      style="padding-top: 7px;"
                      class="form-check-label"
                      for="emailCheck"
                      >Email</label
                    >
                    <div style="float:right;width:85%;padding-bottom:10px">
                      <input
                        type="email"
                        class="form-control"
                        id="emailId"
                        placeholder="Enter email"
                        #enggMail
                        disabled="true"
                      />
                    </div>
                  </div>
                  <textarea
                    #emailtext
                    style="width:340px"
                    class="form-control"
                    rows="5"
                    id="mailTextArea"
                    disabled="true"
                    >{{ mailText }}</textarea
                  >
                  <label style="padding-top:10px">Additional Comments</label>
                  <textarea
                    #comentTextArea
                    style="width:340px"
                    class="form-control"
                    rows="2"
                    id="comentTextArea"
                    disabled="true"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          value="cancelClick"
          (click)="modal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          value="sendClick"
          (click)="
            escalate(
              'escalate',
              enggPhn1.value,
              enggMail.value,
              smstext.value,
              emailtext.value,
              comentTextArea.value
            )
          "
        >
          Send
        </button>
      </div>
    </ng-template>
    <ng-template #descriptionModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Alarm Description</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4" style="text-align:right;">
            <p>Site ID | Name:</p>
            <p>Alarm:</p>
            <p>Generated On:</p>
            <p>Description:</p>
          </div>
          <div class="col-md-8">
            <p style="word-break: break-all;">{{ siteid_sitename }}</p>
            <p style="word-break: break-all;">{{ alarmName }}</p>
            <p style="word-break: break-all;">{{ generatedOn }}</p>
            <p style="word-break: break-all;">{{ description }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          value="closeClick"
          (click)="modal.dismiss('close')"
        >
          Close
        </button>
      </div>
    </ng-template>
  `,
  styles: [
    `
      .modal-footer button {
        width: 150px !important;
      }
    `,
  ],
})
export class ActionRendererComponent implements ICellRendererAngularComp {
  selectedoption = "Action";
  closeResult: string;
  params: any;
  sid = "";
  alarmId = "";
  sitecode = "";
  sitename = "";
  timeelapsed = "";
  description = "";
  siteid_sitename = "";
  generatedOn = "";
  alarms = "";
  cluster = "";
  fieldEnggName = "NA";
  fieldEnggContact = "NA";
  fieldEnggId = "NA";
  smsText = "";
  smsChecks = false;
  mailChecks = false;
  mailText = "";
  ack_dt = "";
  clear_dt = "";
  disableAck = false;
  disableClear = false;
  disableTT = false;
  IsAcknowledged: any;
  ttNumber;
  closed_Dt = "";
  enggPhone = "";
  datetimeformat;
  Severity;
  constructor(
    private modalService: NgbModal,
    config: NgbModalConfig,
    private cdr: ChangeDetectorRef,
    private http: HttpService,
    private globals: Globals,
    private datePipe: DatePipe,
    private urlAuthentication: BindingURLService,
    private alarmPageUrl: AlarmsComponent,
    private apiUrl: ApiService
  ) {
    config.backdrop = "static";
   
  }
  alrPinID;
  alarmName;
  allOpenTime;
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;

    this.alrPinID = this.params.data.AlarmPin;
    this.alarmName = this.params.data.alarms;
    this.generatedOn = this.params.data.generatedOn;
    this.allOpenTime = this.params.data.allOpenTime;
    this.fieldEnggName = this.params.data.fieldEngg;
    this.fieldEnggContact = this.params.data.contact;
    this.timeelapsed = this.params.data.timeElapsed;
    this.sitecode = this.params.data.siteCode;
    this.sitename = this.params.data.sitename;
    this.siteid_sitename = this.sitecode + " | " + this.sitename;
    this.cluster = this.params.data.cluster;
    this.fieldEnggId = this.params.data.fieldEnggID;
    this.ack_dt = this.params.data.Ack_dt;
    this.clear_dt = this.params.data.clear_dt;
    this.IsAcknowledged = this.params.data.IsAcknowledged;
    this.ttNumber = this.params.data.ttNumber;
    this.Severity = this.params.data.Severity;

    this.closed_Dt = this.params.data.closedDt;
    this.description = this.params.data.description
      ? this.params.data.description
      : "";
    if (this.IsAcknowledged > 0) {
      this.disableAck = true;
    }
    if (this.clear_dt != "") {
      this.disableClear = true;
    }
    if (this.ttNumber != "0" && this.ttNumber != "") {
      this.disableTT = true;
    }
    // this.ttNumber=""
    // if (!this.ttNumber) {
    //   this.disableTT = true;
    // }
    if (this.closed_Dt != "") {
      this.disableTT = true;
    }
    if (!this.fieldEnggId) {
      this.fieldEnggId = "NA";
    }
    if (!this.fieldEnggContact) {
      this.fieldEnggContact = "NA";
    }
    if (!this.fieldEnggName) {
      this.fieldEnggName = "NA";
    }

  }
  refresh(): boolean {
    return false;
  }
  optionChanged(
    option,
    ackModal,
    clearModal,
    escalateModal,
    descriptionModal,
    createTT
  ) {
    this.selectedoption = "";
    this.cdr.detectChanges();

    if (option == "Acknowledge" && ackModal != undefined) {
      this.selectedoption = "Action";
      this.openModal(ackModal);
    } else if (option == "Clear" && clearModal != undefined) {
      this.selectedoption = "Action";
      this.openModal(clearModal);
    } else if (option == "Assign") {
      this.selectedoption = "Action";
    } else if (option == "Escalate" && escalateModal != undefined) {
      this.selectedoption = "Action";
      this.smsText =
        "Alarm : " +
        this.alarms +
        "\n" +
        "Site :" +
        this.siteid_sitename +
        "\n" +
        "Cluster :" +
        this.cluster;
      this.mailText =
        'Hi ,\n\n"' +
        this.alarms +
        '" happened for site "' +
        this.siteid_sitename +
        '" on ' +
        this.generatedOn +
        "\n\n" +
        "Thanks,\n iTOC Admin";
      this.openLg(escalateModal);
      this.onChange("smsCheck", true);
      this.onChange("mailCheck", true);
    } else if (option == "Description" && descriptionModal != undefined) {
      this.selectedoption = "Action";
      this.openModal(descriptionModal);
    } else if (option == "dtldashbrd") {
      this.selectedoption = "Action";
      const link = "#/siteDetails";
      const str = '{"siteID":"' + this.sid + '"}';
      const encr = window.btoa(str);
      window.open(link + "?e=" + encr, "_blank");
    } else if (option == "alrmHistory") {
      this.selectedoption = "Action";
      const link = "#/alarmHistory";
 
      const str =
        '{"siteID":"' +
        this.sid +
        '","sitename":"' +
        this.sitename +
        '","siteCode":"' +
        this.sitecode +
        '","alrPinID":"' +
        this.alrPinID +
        '","alarmName":"' +
        this.alarmName +
        '"}';

      const encr = window.btoa(str);
      window.open(link + "?e=" + encr, "_blank");
    } else if (option == "CreateTT") {
      this.selectedoption = "Action";
      this.createTT(this.sid, this.alrPinID);
    }
  }
  onChange(name: string, isChecked: boolean) {
    if (isChecked && name.includes("smsCheck")) {
      this.smsChecks = true;
      $("#smsTextArea").prop("disabled", false);
      $("#enggContact").prop("disabled", false);

      $("#smsTextArea").val(this.smsText);
    } else if (!isChecked && name.includes("smsCheck")) {
      this.smsChecks = false;
      $("#smsTextArea").prop("disabled", true);
      $("#enggContact").prop("disabled", true);
      $("#enggContact").val("");
      $("#smsTextArea").val("");
    } else if (isChecked && name.includes("mailCheck")) {
      this.mailChecks = true;
      $("#mailTextArea").prop("disabled", false);
      $("#emailId").prop("disabled", false);
      $("#comentTextArea").prop("disabled", false);
      $("#mailTextArea").val(this.mailText);
    } else if (!isChecked && name.includes("mailCheck")) {
      this.mailChecks = false;
      $("#mailTextArea").prop("disabled", true);
      $("#emailId").prop("disabled", true);
      $("#comentTextArea").prop("disabled", true);
      $("#mailTextArea").val("");
      $("#emailId").val("");
      $("#comentTextArea").val("");
    }
  }
  /**
   * To open the Export Modal
   * @param content
   */
  openModal(content) {
    this.mailChecks = false;
    this.smsChecks = false;
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  openLg(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else if (reason.includes("ack")) {
      const comment = reason.substring(4, reason.length);
      this.acknowledge(comment);
    } else if (reason.includes("clear")) {
      const comment = reason.substring(6, reason.length);
      this.clearAction(comment);
    } else {
      return `with: ${reason}`;
    }
  }
  createTT(siteID, alarmID) {
    this.alarmPageUrl.showGridLoader = true;
    const jsonObject = {
      siteID: siteID,
      AlarmPin: alarmID,
      alOpenTime: this.allOpenTime,
      AlarmName: this.alarmName,
      siteCode: this.sitecode,
      siteName: this.sitename,
      Severity: this.Severity,
    };
    this.http
      .post(
        this.urlAuthentication.crudApiUrl + this.apiUrl.createTTUrl,
        jsonObject
      )
      .subscribe(
        (res) => {
          this.alarmPageUrl.showGridLoader = false;

          const resp = res;
          if (resp) {
            Swal.fire({ text: resp.response });
            this.alarmPageUrl.searchFun();
          }
        },
        (error) => {
          this.alarmPageUrl.showGridLoader = false;
          console.error(error);
        }
      );
  }

  escalate(option, enggPhn, enggMail, smstext, emailtext, commentText) {
    this.modalService.dismissAll("escalate");
    if (this.smsChecks) {
      if (enggPhn != "" && smstext != "") {
        var matches = enggPhn.match(/[0-9]/g);
        if (enggPhn.length === 10 && matches != "" && matches != undefined) {
          const smsJson = {
            AlarmID: this.alarmId,
            SiteID: this.sid,
            EngineerName: this.fieldEnggName,
            EnginerNumber: enggPhn,
            SMSText: smstext,
          };

          this.http
            .post(
              this.urlAuthentication.itocUrl + this.apiUrl.actionEscalateSMSUrl,
              smsJson
            )
            .subscribe(
              (res) => {
                const getResp: string = JSON.stringify(res.body);
                if (getResp.includes("SMS sending intiated.")) {
                  Swal.fire({
                    text: "Successfully SMS/Email sending intiated",
                    icon: "success",
                  });
                } else {
                  Swal.fire({
                    text: "Could not send SMS, Please try again",
                    icon: "warning",
                  });
                }
              },
              (error) => {
                console.error(error);

                Swal.fire({
                  text: "Could not send SMS, Please try again",
                  icon: "warning",
                });
              }
            );
        } else {
          Swal.fire({
            text: "Please enter a valid contact number",
            icon: "warning",
          });
        }
      } else {
        Swal.fire({
          text: "Please fill all mandatory details to send SMS",
          icon: "warning",
        });
      }
    }
    if (this.mailChecks) {
      if (enggMail != "" && emailtext != "") {
        var mailMatch = enggMail.match(
          /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
        );
        if (mailMatch != "" && mailMatch != undefined) {
          const mailJson = {
            AlarmID: this.alarmId,
            SiteID: this.sid,
            SiteCode: this.sitecode,
            SiteName: this.sitename,
            EngineerName: this.fieldEnggName,
            EngineerMail: enggMail,
            MailText: emailtext,
            AlarmName: this.alarms,
            OpenTime: this.generatedOn,
            TimeElapsed: this.timeelapsed,
            Comments: commentText,
          };
          this.http
            .post(
              this.urlAuthentication.itocUrl +
                this.apiUrl.actionEscalateMailUrl,
              mailJson
            )
            .subscribe(
              (res) => {
                const getResp: string = JSON.stringify(res.body);
                if (getResp.includes("Email sending intiated.")) {
                  Swal.fire({
                    text: "Successfully SMS/Email sending intiated",
                    icon: "success",
                  });
                } else {
                  Swal.fire({
                    text: "Could not send Email, Please try again",
                    icon: "warning",
                  });
                }
              },
              (error) => {
                console.error(error);

                Swal.fire({
                  text: "Could not send Email, Please try again",
                  icon: "warning",
                });
              }
            );
        } else {
          Swal.fire({
            text: "Please enter a valid Email ID",
            icon: "warning",
          });
        }
      } else {
        Swal.fire({
          text: "Please fill all mandatory details to send Email",
          icon: "warning",
        });
      }
    }
    if (!this.smsChecks && !this.mailChecks) {
      Swal.fire({
        text: "Please select the checkboxes to send SMS/Email",
        icon: "warning",
      });
    }
  }
  acknowledge(comment) {
    if (comment != "") {
      const jsonData = {
        AlarmID: this.alarmId,
        Description: comment,
      };
      this.http
        .post(
          this.urlAuthentication.itocUrl + this.apiUrl.actionAckUrl,
          jsonData
        )
        .subscribe(
          (res) => {
            const getImgResp: string = JSON.stringify(res.body);
            if (getImgResp.includes("Alarm Acknowledged.")) {
              Swal.fire({
                text: "Acknowledged and Description updated",
                icon: "success",
              });
            } else {
              Swal.fire({
                text: "Acknowledgement failed !!!, Please try again",
                icon: "warning",
              });
            }
          },
          (error) => {
            console.error(error);

            Swal.fire({
              text: "Acknowledgement failed !!!, Please try again",
              icon: "warning",
            });
          }
        );
    } else {
      Swal.fire({
        text: "Alarm Description should not be empty, Please try again",
        icon: "warning",
      });
    }
  }
  clearAction(comment) {
    const jsonData = { AlarmID: this.alarmId, Description: comment };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.actionClearUrl,
        jsonData
      )
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res.body);
          if (getImgResp.includes("Alarm Cleared.")) {
            Swal.fire({
              text: "Alarm Cleared Successfully",
              icon: "success",
            });
          } else {
            Swal.fire({
              text: "Alarm not cleared!!!, Please try again",
              icon: "warning",
            });
          }
        },
        (error) => {
          console.error(error);

          Swal.fire({
            text: "Alarm not cleared!!!, Please try again",
            icon: "warning",
          });
        }
      );
  }
  setMessage(msg, type) {
    this.globals.message = "";
    this.globals.messageType = "";
    this.globals.message = msg;
    this.globals.messageType = type;
    this.params.context.componentParent.ngBeforeViewInit();
  }
}
